import { Errors } from '@startlibs/form'
import React, { useEffect, useRef } from 'react'
import { getColor, isMobile, smoothScroll } from '@startlibs/utils';
import { Button, Icon } from '@startlibs/components'
import styled, { css } from 'styled-components';
import _ from 'lodash/fp'
import { CategoriesBox } from '../../admin/experts/hooks/useEditCategories'
import { IntakeFormCard } from './PatientDetailsNew';

const PriorityButton = styled(Button)`
  box-shadow: none;
  width: 100%;
  justify-content: flex-start;
  ${props => props.isPriority && css`
    background: ${getColor('lightYellow')};
    color: ${getColor('warning')};
    :before {
      border: none;
    }
    ${Icon} {
      color: ${getColor('warning')};
    }
    :hover {
      opacity: 75%;
      background: ${getColor('lightYellow')};
    }
  `}
`

export const CaseSettingsNew = ({ title, subTitle, scrollTo, NavigationButtons, caseRequest, setCaseRequest, lazyCategories, form }) => {

  const headerRef = useRef()
  isMobile();
  const toggleAsPriority = () => setCaseRequest(_.update('markAsPriority', (v) => v ? null : true))

  useEffect(() => {
    if (scrollTo) {
      smoothScroll({ target: headerRef.current, offset: -200 })
    }
  }, [])

  return <>
    <IntakeFormCard>
      <div>
        {title && <h3>{title}</h3>}
        {subTitle && <p>{subTitle}</p>}
        <>
          <CategoriesBox lazyCategories={lazyCategories} form={form}/>
          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, marginBottom: '0.5rem' }}>Priority</label>
            <PriorityButton
              outline
              icon={caseRequest.markedAsPriority ? "star" : "star-line"}
              onClick={toggleAsPriority}
              isPriority={caseRequest.markedAsPriority}
            >
              {caseRequest.markedAsPriority ? "Remove as priority" : "Mark as priority"}
            </PriorityButton>
          </div>
        </> 
      </div>
      <Errors path={'categories'} />
      <NavigationButtons />
    </IntakeFormCard>
  </>

}